import * as React from "react";
import { FunctionComponent, useEffect, useState } from "react";
import { LiveGameSummary } from "@mancala/core";
import { AuthUser, BotLevel, Theme } from "@mancala/core";
import AppHeader from "../components/headerbar/AppHeader";
import PageContainer from "../components/PageContainer";
import { PlusIcon } from "../components/Icons";
import BotLevelMenu from "../components/BotLevelMenu";
import ActiveGameBanner from "../components/home/ActiveGameBanner";
import TutorialBanner from "../components/home/TutorialBanner";
import LiveGamesSection from "../components/home/LiveGamesSection";
import RecentGamesSection from "../components/home/RecentGamesSection";
import PopularGamesSection from "../components/home/PopularGamesSection";
import "../components/home/Home.css";
import { Context } from "../context/context";
import { useNavigate } from "react-router-dom";
import Util from "../util/Util";
import { useTranslation } from "react-i18next";

const Home: FunctionComponent<{
  context: Context,
  userKey?: string,
  authUser?: AuthUser,
  theme: Theme,
}> = ({ context, userKey, authUser, theme }) => {

  const navigate = useNavigate();

  const [activeGame, setActiveGame] = useState<LiveGameSummary | null>(null);

  useEffect(() => {
    if (!authUser) return;
    let disposed = false;
    context.authService.getAccessToken()
      .then((token) => context.gameStore.getActiveGame(token))
      .then((game) => !disposed && setActiveGame(game))
      .catch((error) => console.error("(Home) Could not load the active game", error));
    return () => { disposed = true; };
  }, [authUser?.id]);

  const { t } = useTranslation();

  const onNewGameClick = () => {
    if(Util.checkConnectionAndMaybeAlert(context, t)) return;
    navigate("/loby")
  };

  const onBotLevelChosen = (level: BotLevel) => {
    if(Util.checkConnectionAndMaybeAlert(context, t)) return;
    navigate(`/loby?bot=${level}`)
  };

  return (
    <PageContainer>
      <AppHeader context={context}>
        <BotLevelMenu context={context} onChoose={onBotLevelChosen} className="btn ghost hide-m" />
        <button className="btn pri hide-m" onClick={onNewGameClick}>
          <PlusIcon />{t("NewGame")}
        </button>
      </AppHeader>
      <main className="wrap">
        {/* On phones the header's actions move here. */}
        <div className="qa show-m">
          <button className="btn pri" onClick={onNewGameClick}><PlusIcon />{t("NewGame")}</button>
          <BotLevelMenu context={context} onChoose={onBotLevelChosen} className="btn ghost" label={t("PlayBot")} />
        </div>
        <TutorialBanner context={context} />
        {activeGame && authUser && (
          <ActiveGameBanner
            game={activeGame}
            userId={authUser.id}
            onContinue={() => navigate(`/game/${activeGame.id}`)} />
        )}
        <LiveGamesSection context={context} />
        <PopularGamesSection context={context} />
        {authUser && <RecentGamesSection context={context} userId={authUser.id} />}
      </main>
    </PageContainer>
  );
};

export default Home;
